export default __webpack_public_path__ + "static/right-a0884e647a9d6eb69bb9ed4a78f1dab1.png";